// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quicksight-container {
  height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.quicksight-container .qs-details-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
}
.quicksight-container .qs-details-header__title {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.quicksight-container .qs-details-header h2 {
  margin: 0;
  color: #333;
  font-weight: 600;
  line-height: 1.2;
}
.quicksight-container .qs-details-header__subtitle {
  margin-top: 0.25rem;
  color: #666;
  font-size: 0.9rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  word-break: break-all;
}
.quicksight-container .dashboard-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.quicksight-container .dashboard-content .loading-container,
.quicksight-container .dashboard-content .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 2rem;
}
.quicksight-container .dashboard-content .loading-container .loading-spinner,
.quicksight-container .dashboard-content .loading-container .error-icon,
.quicksight-container .dashboard-content .error-container .loading-spinner,
.quicksight-container .dashboard-content .error-container .error-icon {
  margin-bottom: 1rem;
}
.quicksight-container .dashboard-content .loading-container p,
.quicksight-container .dashboard-content .error-container p {
  color: #666;
  margin: 0.5rem 0;
}
.quicksight-container .dashboard-content .loading-container h3,
.quicksight-container .dashboard-content .error-container h3 {
  margin: 1rem 0 0.5rem 0;
  color: #333;
}
.quicksight-container .dashboard-content .iframe-container {
  flex: 1;
  width: 100%;
  height: 800px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
}
.quicksight-container .dashboard-content .iframe-container ::ng-deep > iframe {
  height: 100%;
  width: 100%;
}

@media (max-width: 768px) {
  .quicksight-container {
    padding: 0.5rem;
  }
  .quicksight-container .qs-details-header {
    align-items: flex-start;
    gap: 0.5rem;
  }
}
.quicksight-container {
  height: 1750px;
  display: flex;
  flex-direction: column;
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/quick-sight-dashboard/quick-sight-dashboard.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACN;AAEI;EACE,SAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAAN;AAGI;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,+GAAA;EAEA,qBAAA;AAFN;AAME;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAJJ;AAMI;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AAJN;AAMM;;;;EAEE,mBAAA;AAFR;AAKM;;EACE,WAAA;EACA,gBAAA;AAFR;AAKM;;EACE,uBAAA;EACA,WAAA;AAFR;AAMI;EACE,OAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJN;AAMM;EACE,YAAA;EACA,WAAA;AAJR;;AAUA;EACE;IACE,eAAA;EAPF;EASE;IACE,uBAAA;IACA,WAAA;EAPJ;AACF;AAWA;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AATJ","sourcesContent":[".quicksight-container {\n  height: calc(100vh - 200px);\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n\n  .qs-details-header {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #e0e0e0;\n\n    &__title {\n      display: flex;\n      flex-direction: column;\n      min-width: 0;\n    }\n\n    h2 {\n      margin: 0;\n      color: #333;\n      font-weight: 600;\n      line-height: 1.2;\n    }\n\n    &__subtitle {\n      margin-top: 0.25rem;\n      color: #666;\n      font-size: 0.9rem;\n      font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n        \"Courier New\", monospace;\n      word-break: break-all;\n    }\n  }\n\n  .dashboard-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n\n    .loading-container,\n    .error-container {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      height: 100%;\n      text-align: center;\n      padding: 2rem;\n\n      .loading-spinner,\n      .error-icon {\n        margin-bottom: 1rem;\n      }\n\n      p {\n        color: #666;\n        margin: 0.5rem 0;\n      }\n\n      h3 {\n        margin: 1rem 0 0.5rem 0;\n        color: #333;\n      }\n    }\n\n    .iframe-container {\n      flex: 1;\n      width: 100%;\n      height: 800px;\n      border: 1px solid #ddd;\n      border-radius: 8px;\n      overflow: hidden;\n      background: #f8f9fa;\n\n      ::ng-deep > iframe {\n        height: 100%;\n        width: 100%;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .quicksight-container {\n    padding: 0.5rem;\n\n    .qs-details-header {\n      align-items: flex-start;\n      gap: 0.5rem;\n    }\n  }\n}\n\n.quicksight-container {\n    height: 1750px;\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
